import type { MarketplaceFulfillmentStatus } from "@nexus/contracts";

import type { OrderLineVideoReviewStatus } from "@/features/marketplace/types/marketplace.types";

export function isOpsMoveToRevisionDisabled(input: {
  fulfillmentStatus: MarketplaceFulfillmentStatus;
  deliverableReviewStatus?: OrderLineVideoReviewStatus | null;
}): boolean {
  if (input.deliverableReviewStatus) {
    return input.deliverableReviewStatus === "REVISION_REQUESTED";
  }
  return input.fulfillmentStatus === "SENT_FOR_REVISION";
}
